import React, { Component } from 'react';
import { Button,  DatePicker, Select, message } from 'antd';
import SearchRetrieve from '../../../common/SearchRetrieve.new.js';
import SearchMulSelect from '../../../common/SearchMulSelect';
import SelectProvince from '../../../common/SelectProvince';
import $ from '../../../../common/AjaxRequest';
import API_URL from '../../../../common/url';
import moment from 'moment';

const Option = Select.Option;
const monthFormat = 'YYYY-MM';
const { MonthPicker } = DatePicker;
const disabledDate = (current, date) => {
    const prevValue = moment(date).subtract(11, 'M').valueOf();
    const nextValue = moment(date).add(11, 'M').valueOf();
    const currentValue = current.valueOf();
    return current && (currentValue < prevValue || currentValue > nextValue);
};

class Filter extends Component {
    state = {
        searchParams: {},
        leaderOptions: [],
        crcPosition:[],
    }

    componentDidMount() {
        this.queryRecentRecordTime();
        this.queryCrcPosition();
    }

    componentWillReceiveProps(nextProps){
        this.setState({
            activeKey: nextProps.activeKey,
        })
    }

    initialize = () =>{
        this.setState({ searchParams: {} })
    }

    queryRecentRecordTime = () => {
        const options = {
            method: 'POST',
            url: API_URL.user.queryMaxYearMonth,
            data: {},
            dataType: 'json',
            doneResult: res => {
                const { yearMonth } = res;
                this.setQuarter(yearMonth, this.search);
            }
        };
        $.sendRequest(options);
    }

    queryCrcPosition = () => {
        const options = {
            method: 'POST',
            url: API_URL.user.queryCrcPosition,
            data: {},
            dataType: 'json',
            doneResult: res => {
                this.setState({
                    crcPosition:res.data
                })
            }
        };
        $.sendRequest(options);
    }

    search = () => {
        const { searchParams } = this.state;
        const { begin, recordYearMonth } = searchParams;
        const { activeKey } = sessionStorage
        if(!begin && activeKey === '1'){
            message.warning(`请选择工作日期开始时间`);
            return;
        }
        if(!recordYearMonth && activeKey === '1'){
            message.warning(`请选择工作日期结束时间`);
            return;
        }
        if (begin && recordYearMonth) {
            if (moment(begin).valueOf() > moment(recordYearMonth).valueOf()) {
                return message.warning('开始时间不能大于结束时间')
            }
            if (moment(begin).valueOf() < moment(recordYearMonth).add(-11, 'M').valueOf() ) {
                return message.warning('时间范围不能超过一年')
            }
        }
        this.props.search(searchParams);
    }

    export = () => {
        this.props.export();
    }

    saveProvince = (checkedArea) => {
        const { searchParams } = this.state;
        const params = {};
        checkedArea.map(item => {
            params[`params[${item.props.title}]`] = item.key;
        });
        searchParams.areaParams = params;
        this.setState({ searchParams });
    }


    handleDateChange = (date, dateString, key) => {
        // this.setQuarter(dateString);
        const { searchParams } = this.state;
        searchParams[key] = dateString;
        this.setState({ searchParams });
    }

    handleSelectChange = (value, key) => {
        const { searchParams } = this.state;
        searchParams[key] = value;
        this.setState({ searchParams });
    }

    //直线主管
    leaderSelectChange = (value = []) => {
        const { searchParams } = this.state;
        let leaderIds = '';
        value.map(item => {
            leaderIds += `,${item.key}`;
        });
        searchParams.leaderIds = leaderIds ? leaderIds.slice(1) : '';
        this.setState({ searchParams });
    }

    parseLeaderData = res => {
        if ((res.data || res.datas) ) {
            const sourceData = res.data || res.datas;
            const data = sourceData.map(item => ({
                text: `${item.userCompellation}[${item.employeeCode}]`,
                value: item.userId,
                fetching: false,
            }));
            this.setState({ leaderOptions: data });
        } else {
            this.setState({ leaderOptions: [] });
        }
    }

    handleChange = ({ value, text }, key) => {
        const { searchParams } = this.state;
        searchParams[`${key}Id`] = value;
        searchParams[`${key}Name`] = text;
        this.setState({ searchParams });
    }

    setQuarter = (date, callback = () => {}) => {
        const dateObj = date ? moment(date) : moment();
        const year = dateObj.year();
        const quarter = dateObj.quarter();
        let offset = 0;
        // 是否是一季度， 是（年份减一，季度设为四季度）
        const isFirstQuarter = offset && quarter == 1;
        const startMonth = 1 + 3 * ((isFirstQuarter ? 3 : quarter - 1 - offset));
        const endMonth = 3 * ((isFirstQuarter ? 4 : quarter - offset));
        const { searchParams } = this.state;
        searchParams.begin = `${year - (isFirstQuarter ? 1 : 0)}-${startMonth < 10 ? `0${startMonth}` : startMonth}`;
        searchParams.recordYearMonth = `${year- (isFirstQuarter ? 1 : 0)}-${endMonth < 10 ? `0${endMonth}` : endMonth}`;
        this.setState({ searchParams },() => { callback() });
    }

    render () {
        const { activeKey } = this.props;
        const { searchParams, leaderOptions, crcPosition } = this.state;
        const { begin, recordYearMonth, workStatus, userName, positionName, leaderUserName } = searchParams;
        const crcPositionOption = crcPosition.map( el => <Option key={el} value={el}>{el}</Option>)
        return (
            <div style={{ marginBottom: 16 }}>
                <div className="search-bar">
                    {
                        activeKey === '1' &&
                        <div className="search-item">
                            <label htmlFor="" className="ui-label">时间</label>
                            <MonthPicker
                                allowClear={false}
                                placeholder="请选择"
                                format={monthFormat}
                                style={{ width: 100 }}
                                value={begin ? moment(begin) : null}
                                // disabledDate={current => disabledDate(current, moment(begin))}
                                onChange={(date, dateString) => this.handleDateChange(date, dateString, 'begin')}
                            />
                        </div>
                    }
                    {
                        activeKey === '1' &&
                        <div className="search-item">
                            <label htmlFor="" className="ui-label">~</label>
                            <MonthPicker
                                allowClear={false}
                                placeholder="请选择"
                                format={monthFormat}
                                style={{ width: 100 }}
                                value={recordYearMonth ? moment(recordYearMonth) : null}
                                // disabledDate={current => disabledDate(current, moment(recordYearMonth))}
                                onChange={(date, dateString) => this.handleDateChange(date, dateString, 'recordYearMonth')}
                            />
                        </div>
                    }
                    <div className="search-item">
                        <label className="ui-label">姓名/工号</label>
                        <SearchRetrieve
                            keyword='nameCode'
                            style={{ width: 142 }}
                            params={{ limit: 20 }}
                            value={userName}
                            placeholder="输入姓名/工号检索"
                            url={API_URL.user.queryPositionCrcList}
                            config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                            onChange={option => this.handleChange(option, 'user')}
                        />
                    </div>
                    {
                        activeKey === '1' &&
                        <div className="search-item">
                            <label className="ui-label">工作城市</label>
                            <SelectProvince saveProvince={this.saveProvince} />
                        </div>
                    }
                    {
                        activeKey === '1' &&
                        <div className="search-item">
                            <label className="ui-label">职位</label>
                            <Select
                                allowClear={true}
                                placeholder="请选择"
                                value={positionName}
                                onChange={value => this.handleSelectChange(value, 'positionName')}
                                style={{ width: 160 }}
                            >
                                {crcPositionOption}
                            </Select>
                        </div>
                    }
                    {
                        activeKey === '1' &&
                        <div className="search-item">
                            <label htmlFor="" className="ui-label">主管领导</label>
                            <SearchRetrieve
                                keyword='keyword'
                                style={{ width: 142 }}
                                value={leaderUserName}
                                params={{ limit: 20, dimissionStatus: 'WORKING' }}
                                placeholder="输入姓名/工号检索"
                                url={API_URL.investigation.queryUserByKey}
                                config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                                onChange={option => this.handleChange(option, 'leaderUser')}
                            />
                        </div>
                    }
                    <div className="search-item">
                            <label htmlFor="" className="ui-label">状态</label>
                            <Select
                                placeholder="请选择"
                                value={workStatus}
                                onChange={value => this.handleSelectChange(value, 'workStatus')}
                                style={{width:90}}
                                allowClear={true}
                            >
                                <Option value="WORKING">在职</Option>
                                <Option value="LEFT">离职</Option>
                            </Select>
                    </div>
                </div>
                <div className="search-bar flex-recordYearMonth">
                    <div className="search-item">
                    <Button type="primary" onClick={this.search}>搜索</Button>
                    <Button type="primary" onClick={this.export}>导出</Button>
                    </div>
                </div>
            </div>
        )
    }
}

export default Filter;


// WEBPACK FOOTER //
// ./src/components/user/crcPostRank/components/Filter.js